// extracted by mini-css-extract-plugin
export default {"labelContainer":"labels-module__labelContainer--gEfYq","labelLink":"labels-module__labelLink--rVvrD"};